import { useSession } from '#src/app/shared/hooks/session';

/**
 * The channel this signer arrived through — the session-persisted copy of the arrival `utm_medium`.
 * Free text, so it is trimmed and lowercased before anything matches on it.
 *
 * Normalised in one place so a channel match can't drift between callers.
 */
export function useArrivalChannel(): string | undefined {
	const session = useSession();

	// oxlint-disable-next-line typescript/no-unnecessary-condition -- trackingData is a Record<string, string> (TrackingData scalar); noUncheckedIndexedAccess is off, so TS types current_medium as always-defined even though the key may genuinely be absent at runtime
	return session.trackingData.current_medium?.trim().toLowerCase();
}
